<template>
  <div>
    <breadcrumbs class="bg-light text-muted"></breadcrumbs>
    <div class="p-5 bg-white rounded">

      <spinner v-if="loading"></spinner>

      <div v-else-if="channels.length === 0">
        <empty-list-view
          title="Create your first channel!"
          description="Channel represents a medium through which you can send and receive messages. Each channel has a type which
          specifies the platform connected: Facebook Messenger, Viber, etc.">
          <add-new-channel-link slot="button-add"></add-new-channel-link>
        </empty-list-view>
      </div>

      <div v-else>
        <add-new-channel-link></add-new-channel-link>
        <table class="table table-hover">
          <thead>
          <tr>
            <th></th>
            <th>Name</th>
            <th>Channel Type</th>
            <th>Id</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="channel in channels" :key="channel.id">
            <td>
              <channel-icon :channel="channel" class="rounded-circle" width="25px"></channel-icon>
            <td>
              <router-link v-if="channel.id"
                           :to="{ name: 'administration.channel-detail.info', params: {id: channel.id}}">
                {{channel.name}}
              </router-link>
            </td>
            <td>{{channel.type | channelType}}</td>
            <td>{{channel.id}}</td>
            <td class="text-right">
              <router-link v-if="channel.id"
                           role="button" class="btn btn-outline-primary btn-sm mr-2"
                           :to="{ name: 'administration.channel-detail.info', params: {id: channel.id}}">
                Detail
              </router-link>
              <a href="#" role="button" @click="openDeleteConfirm(channel)">
                <icon class="btn-icon text-danger" name="trash" scale="1.0"/>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
        <b-pagination v-model="currentPage"
                      :total-rows="totalItems"
                      :per-page="listMaxSize"
                      :hide-goto-end-buttons="hideGoToEndButtons"
                      @change="pageChanged">
        </b-pagination>
      </div>
      <modal-confirm-delete
        :showModal="showDeleteModal"
        @channelDeleted="channelDeleted"
        :channel="channelForDeletion">
      </modal-confirm-delete>
    </div>
  </div>
</template>

<script>
  import ChannelIcon from '@/components/common/ChannelIcon'
  import ConfirmDelete from '@/components/administration/channel/common/ConfirmDeleteChannel'
  import Breadcrumbs from '@/components/common/Breadcrumbs'
  import AddNewChannelLink from '@/components/administration/channel/common/AddNewChannelLink'
  import channelService from '@/services/amio-api/channel.service'
  import EmptyListView from '@/components/administration/common/EmptyListView'
  import 'vue-awesome/icons/trash'
  import loadingMixin from '@/mixins/loading.mixin'

  export default {
    metaInfo: {
      title: 'Channels'
    },

    mixins: [loadingMixin],

    components: {
      'add-new-channel-link': AddNewChannelLink,
      'breadcrumbs': Breadcrumbs,
      'channel-icon': ChannelIcon,
      'empty-list-view': EmptyListView,
      'modal-confirm-delete': ConfirmDelete
    },

    store: {
      showDeleteModal: 'administration.channelDetail.showDeleteModal'
    },

    data: () => ({
      channels: [],
      channelForDeletion: {},
      totalItems: null,
      listMaxSize: parseInt(process.env.VUE_APP_LIST_MAX_SIZE),
      currentPage: 1
    }),

    computed: {
      hideGoToEndButtons() {
        return this.totalItems < parseInt(process.env.VUE_APP_PAGINATION_ITEMS_SHOW_END_BUTTONS)
      }
    },

    methods: {
      setData({items, totalItems}) {
        this.channels = items
        this.totalItems = totalItems
      },

      pageChanged(page) {
        this.currentPage = page
        this.$router.push({query: {page: page}})
        return this.getChannels()
      },

      openDeleteConfirm(channel) {
        this.channelForDeletion = channel
        this.showDeleteModal = true
      },

      channelDeleted() {
        this.getChannels()
          .then(() => {
            // adjust pagination overflow - might happen when deleting
            if (this.channels.length > 0 || this.currentPage <= 1) return

            return this.pageChanged(this.currentPage - 1)
          })
      },

      getChannels() {
        const page = this.$route.query.page ? parseInt(this.$route.query.page) : this.currentPage
        const offset = (page - 1) * this.listMaxSize
        this.loading = true
        return channelService.list({offset, max: this.listMaxSize})
          .then(this.setData)
          .then(() => {
            this.loading = false
            // set currentPage after totalItems are set due to b-pagination
            this.currentPage = page
          })
      }
    },

    mounted() {
      this.getChannels()
    }
  }

</script>

<style>

  td img {
    /* hack for Safari - the rounded icon is rendered weirdly without it */
    display: block;
  }
</style>
